__turbopack_context__.v({
  "active": "_5WGEYq_active",
  "arrow": "_5WGEYq_arrow",
  "bg-standard": "_5WGEYq_bg-standard",
  "bg-subtle": "_5WGEYq_bg-subtle",
  "bullet": "_5WGEYq_bullet",
  "disabled": "_5WGEYq_disabled",
  "nav": "_5WGEYq_nav",
  "placeholder": "_5WGEYq_placeholder",
  "section": "_5WGEYq_section",
  "slides": "_5WGEYq_slides",
  "text": "_5WGEYq_text",
});
